import { render, staticRenderFns } from "./GenerateJig.vue?vue&type=template&id=bb1e084a"
import script from "./GenerateJig.vue?vue&type=script&lang=ts"
export * from "./GenerateJig.vue?vue&type=script&lang=ts"
import style0 from "./GenerateJig.vue?vue&type=style&index=0&id=bb1e084a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports